import axios from "axios";
import { BASE_URL } from "../constants/Constants";
import { cookieUtils } from "./cookieUtils";
import { ErrorToast } from "../components/toastMessage";
// import { useNavigate } from "react-router-dom";
// import { useQueryClient } from "@tanstack/react-query";

let url = `${BASE_URL}/api`;

if (process.env.NODE_ENV === "production") {
  // TODO
  url = `${BASE_URL}/api`;
}

export const _axios = axios.create({ baseURL: url });
_axios.interceptors.request.use(
  (request) => {
    // request.headers.Authorization = localStorage.getItem("token") || "";

    request.headers.Authorization =  cookieUtils.getSecureCookie("token") || "";
    return request;
  },
  (err) => Promise.reject(err)
);
_axios.interceptors.response.use(
  (response) => {
    console.log("Interceptor response:", response);

    // Check if the response indicates an error (success === 0) and has a message
    if (response?.data?.success === 0 && response?.data?.message) {
      ErrorToast(response.data.message);
    }
    return response;
  },
  (error) => {
    // Optional: If the error response has a message, show it as well
    if (error?.response?.data?.message) {
      ErrorToast(error.response.data.message);
    }
    return Promise.reject(error);
  }
);
// _axios.interceptors.response.use(
//   (response: any) => {
//     if (response.success === 0 && response.message === 'Access Denied!') {
//       const qc = useQueryClient();
//       const navigate = useNavigate();
//       qc.clear();
//       localStorage.clear();
//       navigate("/onboarding/login");
//     }
//     return response;
//   },
//   (err) => Promise.reject(err)
// );


